import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
const styles = {
  termsText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "justify",
    border: "2px solid black",
    padding: "15px",
  },
};

function ContractHTML({ classes, agreementType }) {
  const [iframe, setIframe] = useState({
    __html: "<html>",
  });

  useEffect(() => {
    async function fetchAgreement() {
      const res = await fetch(
        `https://interface.mcsnet.ca/guest/agreement?type=${agreementType}`
      );
      const resHtml = await res.text();
      setIframe({
        __html: resHtml,
      });
    }
    fetchAgreement();
  }, [agreementType]);

  return (
    <div
      className={classes.termsText}
      key="agreement"
      dangerouslySetInnerHTML={iframe}
    />
  );
}

export default withStyles(styles)(ContractHTML);
